import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type AllEventsFragmentFragment = { __typename?: 'Event', id: string, name?: string | null, description?: string | null, image_url?: string | null, start_date?: string | null, end_date?: string | null, event_participants?: Array<{ __typename?: 'EventAccount', id: string, name?: string | null, description?: string | null, email?: string | null, item_locations?: Array<{ __typename?: 'ItemLocation', id: string, name: string, event?: { __typename?: 'EventReduced', id?: string | null, name?: string | null } | null }> | null, authorized_signers: Array<{ __typename?: 'AuthorizedSigner', id: string, name: string, event_account_id: string, event_account_name: string, allowed_item_locations?: Array<{ __typename?: 'ItemLocation', id: string, name: string, event_id?: string | null }> | null }> }> | null };

export const AllEventsFragmentFragmentDoc = gql`
    fragment allEventsFragment on Event {
  id
  name
  description
  image_url
  start_date
  end_date
  event_participants {
    id
    name
    description
    email
    item_locations {
      id
      name
      event {
        id
        name
      }
    }
    authorized_signers {
      id
      name
      event_account_id
      event_account_name
      allowed_item_locations {
        id
        name
        event_id
      }
    }
  }
}
    `;